import React, { useState } from "react";
import { PlusIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../contexts/LanguageContext";
import CommonPageHeader from "../components/common/CommonPageHeader";
import ContractLists from "components/contracts/ContractLists";
import { useAuth } from "contexts/AuthContext";
import DocumentGeneratorModal from "components/documents/DocumentGeneratorModal";
import { useContracts } from "hooks/useContracts";

const Contracts = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  const { refreshContracts } = useContracts();
  const [isGeneratorModalOpen, setIsGeneratorModalOpen] = useState(false);

  const handleCloseGeneratorModal = () => {
    setIsGeneratorModalOpen(false);
    // Refresh the contracts list when the modal is closed
    refreshContracts();
  };

  return (
    <div className="space-y-3 sm:space-y-4 pb-4">
      <CommonPageHeader
        title={t("contracts.title")}
        subtitle="Szerződések kezelése és dokumentumok"
        icon={DocumentTextIcon}
        showLastUpdate={false}
      >
        {user?.role !== 'user' && (
          <button
            onClick={() => setIsGeneratorModalOpen(true)}
            className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors"
          >
            <PlusIcon className="w-5 h-5 mr-2" />
            {t("contracts.newContract")}
          </button>
        )}
      </CommonPageHeader>

      {/* Contracts list */}
      <ContractLists />

      {/* Document Generator Modal */}
      <DocumentGeneratorModal
        isOpen={isGeneratorModalOpen}
        onClose={handleCloseGeneratorModal}
        documentDataProvider={null}
        forceContractTemplates={true}
      />
    </div>
  );
};

export default Contracts;

